import { useState } from 'react';
import { useIntl } from 'react-intl';

import UserSelect from '~/components/Shared/UserSelect/UserSelect';
import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { PilotId } from '~/eds/src/types/PilotId';
import { Nullable } from '~/types/Nullable';

interface Props {
  assignedUserId: Nullable<PilotId>;
  excludedUserIds: PilotId[];
  onAssignmentChange: (newAssigneeId: PilotId) => void;
  onCancel: () => void;
}

export const TicketUserAssignment = ({
  assignedUserId,
  excludedUserIds,
  onAssignmentChange,
  onCancel,
}: Props) => {
  const intl = useIntl();
  const [assigneeId, setAssigneeId] =
    useState<Nullable<PilotId>>(assignedUserId);

  return (
    <Layout align="center">
      <UserSelect
        isMulti={false}
        name="ticket-user-assignment"
        notAvailableUsers={excludedUserIds}
        value={assigneeId}
        onChange={(newAssigneeId) => setAssigneeId(newAssigneeId)}
      />
      <Button
        icon="check"
        iconPosition="left"
        variant="action"
        text={intl.formatMessage({
          id: 'TicketUserAssignment.assign',
          defaultMessage: 'Assign',
          description: 'Action button for assigning a user to a ticket task',
        })}
        disabled={!assigneeId}
        onClick={() => {
          if (assigneeId) {
            onAssignmentChange(assigneeId);
          }
        }}
      />
      <Button
        variant="action"
        text={intl.formatMessage({
          id: 'TicketUserAssignment.cancel',
          defaultMessage: 'Cancel',
          description: 'Action button for canceling a user assignment',
        })}
        onClick={onCancel}
      />
    </Layout>
  );
};
